import { Helmet } from "react-helmet";
import { defaultTitle } from "../config";

/**
 * @param {React.Component} Component
 * @param {Object} options
 * @param {string} [options.documentTitle]
 * @param {string} [options.pageTitle]
 * @returns {Function}
 */

const withDocumentTitle = (Component, options) => (props) => {
  return (
    <div className="tw-relative">
      <Helmet>
        <title>
          {`${options?.documentTitle || options?.pageTitle} - ${defaultTitle}`}
        </title>
      </Helmet>

      {options?.pageTitle && (
        <h1 className="tw-text-center tw-mb-4">{options.pageTitle}</h1>
      )}

      <Component {...props} />
    </div>
  );
};

export default withDocumentTitle;
